import { setupAnalytics } from './setup';

setupAnalytics();
